import FingerprintJS from '@fingerprintjs/fingerprintjs';

export async function generateDeviceId() {
    const storageKey = 'X-Device-ID';
    let deviceId = localStorage.getItem(storageKey);

    if (!deviceId) {
        // 使用FingerprintJS生成设备指纹
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        deviceId = result.visitorId;

        // 存储指纹ID
        localStorage.setItem(storageKey, deviceId);
        sessionStorage.setItem(storageKey, deviceId);
    }

    // 处理localStorage被清除的特殊情况
    if (!localStorage.getItem(storageKey) && sessionStorage.getItem(storageKey)) {
        deviceId = sessionStorage.getItem(storageKey);
        localStorage.setItem(storageKey, deviceId);
    }

    return deviceId;
}